<template>
  <!-- Noticias -->
  <section class="py-5" id="noticias">
    <div class="container-fluid text-center">
      <div class="row align-items-center justify-content-center bg-aquamarine" style="height:15vh;">
        <div class="col-md-12">
          <h1 class="text-white">NOTÍCIAS</h1>
        </div>
      </div>
      <div class="row text-center">
        <div class="col-md-12">
          <div class="card-group">
            <a v-for="noticia in lastNoticias" :key="noticia.titulo"
               :href="noticia.link"
               class="bg-primary card border noticia">
              <img class="card-img-top" :src="noticia.imagem" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title">{{ noticia.titulo }}</h5>
                <p class="card-text">{{ noticia.desc }}</p>
                <p class="card-text"><small>{{ noticia.author }}</small></p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-12">
          <a class="btn btn-danger btn-lg m-2"
             href="https://www.toledo.pr.gov.br/home-page-news" target="_blank">Mais Notícias</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Bloco5Noticias",
  computed: {
    lastNoticias()
    {
      if (this.$store.state.noticias) {
        return this.$store.state.noticias;
      } else {
        return {"data": {"link":"","data":""} }
      }
    }
  },
}
</script>

<style scoped>
a.noticia {
  color: white;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects; }

a {
  color: #12bbad;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects; }
a:hover {
  color: white;
  text-decoration: underline; }
</style>